import React from 'react'
import PropTypes from 'prop-types'
import { BaseComponent, FullscreenModal } from 'belle-js'
import styles from './TimeoutModal.module.scss'
import connectModal from 'connectModal'
import logout from 'utils/Client/authentication.js'
import { verifyUser } from 'utils/Client/apiRequest.js'
import { trackAnalyticsEvent } from 'analytics'

class TimeoutModal extends BaseComponent {

  constructor (props) {
    super(props)

    this.state = {
      buttonDisabled: false
    }

    this.bind('handleLogoutOnClick', 'handleSessionPing')
  }

  handleLogoutOnClick (e) {
    this.setState({ buttonDisabled: true })
    logout('marketing')
  }

  handleSessionPing (e) {
    this.setState({ buttonDisabled: true })
    verifyUser().then(() => {
      this.setState({ buttonDisabled: false })
      this.props.closeModal()
    })
  }

  render () {
    const  {
      isOpen,
      isActiveModal,
    } = this.props

    return  (
      <FullscreenModal
        isOpen={isOpen}
        isActiveModal={isActiveModal}
        onClose={this.handleSessionPing}
        className={styles.modal}
        data-test-id="timeoutPopup"
        testId="timeoutPopup">
        <div className={styles.container}>
          <div className={styles.title}>You still there?</div>
          <div className={styles.text}>
          You&#39;ve been idle for a little while,
          so we&#39;ll log you out in two minutes to help keep your Ellevest account safe.
          </div>
          <div className={styles.actions}>
            <button
              data-test-id="continue"
              type="button"
              className="button button--primary"
              onClick={(e) => {
                this.handleSessionPing(e)
                trackAnalyticsEvent('I\'m Not Done Clicked')
              }}
              disabled={this.state.buttonDisabled}>
                WAIT, I&#39;M NOT DONE
            </button>
            <button
              data-test-id="logout"
              type="button"
              className="button button--text logout"
              onClick={(e) => {
                this.handleLogoutOnClick(e)
                trackAnalyticsEvent('Logout Clicked')
              }}
              disabled={this.state.buttonDisabled}>
                LOG ME OUT NOW
            </button>
          </div>
        </div>
      </FullscreenModal>
    )
  }

}

TimeoutModal.defaultProps = {
  isActiveModal: false,
  onClose: null,
}

TimeoutModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isActiveModal: PropTypes.bool,
  onClose: PropTypes.func,
  closeModal: PropTypes.func.isRequired,
}

export { TimeoutModal }
export default connectModal(TimeoutModal, 'timeoutModal')



// WEBPACK FOOTER //
// ./src/components/Client/Modals/TimeoutModal/TimeoutModal.jsx